module.exports = __webpack_public_path__ + "static/media/sfl_2.fe45cb7a.jpg";